function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _getOptions, _addEventHandlerForFile, _addEventHandlerIfFileStillExists, _uploadLocalFile, _uploadRemoteFile;

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

var _require = require('nanoid/non-secure'),
    nanoid = _require.nanoid;

var _require2 = require('@uppy/companion-client'),
    Provider = _require2.Provider,
    RequestClient = _require2.RequestClient,
    Socket = _require2.Socket;

var emitSocketProgress = require('@uppy/utils/lib/emitSocketProgress');

var getSocketHost = require('@uppy/utils/lib/getSocketHost');

var EventTracker = require('@uppy/utils/lib/EventTracker');

var ProgressTimeout = require('@uppy/utils/lib/ProgressTimeout');

var ErrorWithCause = require('@uppy/utils/lib/ErrorWithCause');

var NetworkError = require('@uppy/utils/lib/NetworkError');

var isNetworkError = require('@uppy/utils/lib/isNetworkError');

var _require3 = require('@uppy/utils/lib/RateLimitedQueue'),
    internalRateLimitedQueue = _require3.internalRateLimitedQueue; // See XHRUpload


function buildResponseError(xhr, error) {
  if (isNetworkError(xhr)) return new NetworkError(error, xhr);
  var err = new ErrorWithCause('Upload error', {
    cause: error
  });
  err.request = xhr;
  return err;
} // See XHRUpload


function setTypeInBlob(file) {
  var dataWithUpdatedType = file.data.slice(0, file.data.size, file.meta.type);
  return dataWithUpdatedType;
}

function addMetadata(formData, meta, opts) {
  var metaFields = Array.isArray(opts.metaFields) ? opts.metaFields // Send along all fields by default.
  : Object.keys(meta);
  metaFields.forEach(function (item) {
    formData.append(item, meta[item]);
  });
}

function createFormDataUpload(file, opts) {
  var formPost = new FormData();
  addMetadata(formPost, file.meta, opts);
  var dataWithUpdatedType = setTypeInBlob(file);

  if (file.name) {
    formPost.append(opts.fieldName, dataWithUpdatedType, file.meta.name);
  } else {
    formPost.append(opts.fieldName, dataWithUpdatedType);
  }

  return formPost;
}

var createBareUpload = function createBareUpload(file) {
  return file.data;
};

module.exports = (_getOptions = /*#__PURE__*/_classPrivateFieldLooseKey("getOptions"), _addEventHandlerForFile = /*#__PURE__*/_classPrivateFieldLooseKey("addEventHandlerForFile"), _addEventHandlerIfFileStillExists = /*#__PURE__*/_classPrivateFieldLooseKey("addEventHandlerIfFileStillExists"), _uploadLocalFile = /*#__PURE__*/_classPrivateFieldLooseKey("uploadLocalFile"), _uploadRemoteFile = /*#__PURE__*/_classPrivateFieldLooseKey("uploadRemoteFile"), /*#__PURE__*/function () {
  function MiniXHRUpload(_uppy, _opts) {
    _classCallCheck(this, MiniXHRUpload);

    Object.defineProperty(this, _uploadRemoteFile, {
      value: _uploadRemoteFile2
    });
    Object.defineProperty(this, _uploadLocalFile, {
      value: _uploadLocalFile2
    });
    Object.defineProperty(this, _addEventHandlerIfFileStillExists, {
      value: _addEventHandlerIfFileStillExists2
    });
    Object.defineProperty(this, _addEventHandlerForFile, {
      value: _addEventHandlerForFile2
    });
    Object.defineProperty(this, _getOptions, {
      value: _getOptions2
    });
    this.uppy = _uppy;
    this.opts = _objectSpread({
      validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
      }
    }, _opts);
    this.requests = _opts[internalRateLimitedQueue];
    this.uploaderEvents = Object.create(null);
    this.i18n = _opts.i18n;
  }

  _createClass(MiniXHRUpload, [{
    key: "uploadFile",
    value: function uploadFile(id, current, total) {
      var file = this.uppy.getFile(id);

      if (file.error) {
        throw new Error(file.error);
      } else if (file.isRemote) {
        return _classPrivateFieldLooseBase(this, _uploadRemoteFile)[_uploadRemoteFile](file, current, total);
      }

      return _classPrivateFieldLooseBase(this, _uploadLocalFile)[_uploadLocalFile](file, current, total);
    }
  }]);

  return MiniXHRUpload;
}());

function _getOptions2(file) {
  var _file$xhrUpload;

  var uppy = this.uppy;
  var overrides = uppy.getState().xhrUpload;

  var opts = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.opts), overrides || {}), file.xhrUpload || {}), {}, {
    headers: _objectSpread(_objectSpread(_objectSpread({}, this.opts.headers), overrides == null ? void 0 : overrides.headers), (_file$xhrUpload = file.xhrUpload) == null ? void 0 : _file$xhrUpload.headers)
  });

  return opts;
}

function _addEventHandlerForFile2(eventName, fileID, eventHandler) {
  this.uploaderEvents[fileID].on(eventName, function (targetFileID) {
    if (fileID === targetFileID) eventHandler();
  });
}

function _addEventHandlerIfFileStillExists2(eventName, fileID, eventHandler) {
  var _this = this;

  this.uploaderEvents[fileID].on(eventName, function () {
    if (_this.uppy.getFile(fileID)) eventHandler();
  });
}

function _uploadLocalFile2(file, current, total) {
  var _this2 = this;

  var opts = _classPrivateFieldLooseBase(this, _getOptions)[_getOptions](file);

  this.uppy.log("uploading ".concat(current, " of ").concat(total));
  return new Promise(function (resolve, reject) {
    // This is done in index.js in the S3 plugin.
    // this.uppy.emit('upload-started', file)
    var data = opts.formData ? createFormDataUpload(file, opts) : createBareUpload(file, opts);
    var xhr = new XMLHttpRequest();
    _this2.uploaderEvents[file.id] = new EventTracker(_this2.uppy);
    var timer = new ProgressTimeout(opts.timeout, function () {
      xhr.abort(); // eslint-disable-next-line no-use-before-define

      queuedRequest.done();
      var error = new Error(_this2.i18n('timedOut', {
        seconds: Math.ceil(opts.timeout / 1000)
      }));

      _this2.uppy.emit('upload-error', file, error);

      reject(error);
    });
    var id = nanoid();
    xhr.upload.addEventListener('loadstart', function () {
      _this2.uppy.log("[AwsS3/XHRUpload] ".concat(id, " started"));
    });
    xhr.upload.addEventListener('progress', function (ev) {
      _this2.uppy.log("[AwsS3/XHRUpload] ".concat(id, " progress: ").concat(ev.loaded, " / ").concat(ev.total)); // Begin checking for timeouts when progress starts, instead of loading,
      // to avoid timing out requests on browser concurrency queue


      timer.progress();

      if (ev.lengthComputable) {
        _this2.uppy.emit('upload-progress', file, {
          uploader: _this2,
          bytesUploaded: ev.loaded,
          bytesTotal: ev.total
        });
      }
    });
    xhr.addEventListener('load', function (ev) {
      _this2.uppy.log("[AwsS3/XHRUpload] ".concat(id, " finished"));

      timer.done(); // eslint-disable-next-line no-use-before-define

      queuedRequest.done();

      if (_this2.uploaderEvents[file.id]) {
        _this2.uploaderEvents[file.id].remove();

        _this2.uploaderEvents[file.id] = null;
      }

      if (opts.validateStatus(ev.target.status, xhr.responseText, xhr)) {
        var _body = opts.getResponseData(xhr.responseText, xhr);

        var uploadURL = _body[opts.responseUrlFieldName];
        var uploadResp = {
          status: ev.target.status,
          body: _body,
          uploadURL: uploadURL
        };

        _this2.uppy.emit('upload-success', file, uploadResp);

        if (uploadURL) {
          _this2.uppy.log("Download ".concat(file.name, " from ").concat(uploadURL));
        }

        return resolve(file);
      }

      var body = opts.getResponseData(xhr.responseText, xhr);
      var error = buildResponseError(xhr, opts.getResponseError(xhr.responseText, xhr));
      var response = {
        status: ev.target.status,
        body: body
      };

      _this2.uppy.emit('upload-error', file, error, response);

      return reject(error);
    });
    xhr.addEventListener('error', function () {
      _this2.uppy.log("[AwsS3/XHRUpload] ".concat(id, " errored"));

      timer.done(); // eslint-disable-next-line no-use-before-define

      queuedRequest.done();

      if (_this2.uploaderEvents[file.id]) {
        _this2.uploaderEvents[file.id].remove();

        _this2.uploaderEvents[file.id] = null;
      }

      var error = buildResponseError(xhr, opts.getResponseError(xhr.responseText, xhr));

      _this2.uppy.emit('upload-error', file, error);

      return reject(error);
    });
    xhr.open(opts.method.toUpperCase(), opts.endpoint, true); // IE10 does not allow setting `withCredentials` and `responseType`
    // before `open()` is called. It’s important to set withCredentials
    // to a boolean, otherwise React Native crashes

    xhr.withCredentials = Boolean(opts.withCredentials);

    if (opts.responseType !== '') {
      xhr.responseType = opts.responseType;
    }

    Object.keys(opts.headers).forEach(function (header) {
      xhr.setRequestHeader(header, opts.headers[header]);
    });

    var queuedRequest = _this2.requests.run(function () {
      xhr.send(data);
      return function () {
        // eslint-disable-next-line no-use-before-define
        timer.done();
        xhr.abort();
      };
    }, {
      priority: 1
    });

    _classPrivateFieldLooseBase(_this2, _addEventHandlerForFile)[_addEventHandlerForFile]('file-removed', file.id, function () {
      queuedRequest.abort();
      reject(new Error('File removed'));
    });

    _classPrivateFieldLooseBase(_this2, _addEventHandlerIfFileStillExists)[_addEventHandlerIfFileStillExists]('cancel-all', file.id, function () {
      queuedRequest.abort();
      reject(new Error('Upload cancelled'));
    });
  });
}

function _uploadRemoteFile2(file) {
  var _this3 = this;

  var opts = _classPrivateFieldLooseBase(this, _getOptions)[_getOptions](file); // This is done in index.js in the S3 plugin.
  // this.uppy.emit('upload-started', file)


  var metaFields = Array.isArray(opts.metaFields) ? opts.metaFields // Send along all fields by default.
  : Object.keys(file.meta);
  var Client = file.remote.providerOptions.provider ? Provider : RequestClient;
  var client = new Client(this.uppy, file.remote.providerOptions);
  return client.post(file.remote.url, _objectSpread(_objectSpread({}, file.remote.body), {}, {
    endpoint: opts.endpoint,
    size: file.data.size,
    fieldname: opts.fieldName,
    metadata: Object.fromEntries(metaFields.map(function (name) {
      return [name, file.meta[name]];
    })),
    httpMethod: opts.method,
    useFormData: opts.formData,
    headers: opts.headers
  })).then(function (res) {
    return new Promise(function (resolve, reject) {
      var token = res.token;
      var host = getSocketHost(file.remote.companionUrl);
      var socket = new Socket({
        target: "".concat(host, "/api/").concat(token),
        autoOpen: false
      });
      _this3.uploaderEvents[file.id] = new EventTracker(_this3.uppy);

      var queuedRequest = _this3.requests.run(function () {
        socket.open();

        if (file.isPaused) {
          socket.send('pause', {});
        }

        return function () {
          return socket.close();
        };
      });

      _classPrivateFieldLooseBase(_this3, _addEventHandlerForFile)[_addEventHandlerForFile]('file-removed', file.id, function () {
        socket.send('cancel', {});
        queuedRequest.abort();
        resolve("upload ".concat(file.id, " was removed"));
      });

      _classPrivateFieldLooseBase(_this3, _addEventHandlerIfFileStillExists)[_addEventHandlerIfFileStillExists]('cancel-all', file.id, function () {
        socket.send('cancel', {});
        queuedRequest.abort();
        resolve("upload ".concat(file.id, " was canceled"));
      });

      _classPrivateFieldLooseBase(_this3, _addEventHandlerForFile)[_addEventHandlerForFile]('upload-retry', file.id, function () {
        socket.send('pause', {});
        socket.send('resume', {});
      });

      _classPrivateFieldLooseBase(_this3, _addEventHandlerIfFileStillExists)[_addEventHandlerIfFileStillExists]('retry-all', file.id, function () {
        socket.send('pause', {});
        socket.send('resume', {});
      });

      socket.on('progress', function (progressData) {
        return emitSocketProgress(_this3, progressData, file);
      });
      socket.on('success', function (data) {
        var body = opts.getResponseData(data.response.responseText, data.response);
        var uploadURL = body[opts.responseUrlFieldName];
        var uploadResp = {
          status: data.response.status,
          body: body,
          uploadURL: uploadURL,
          bytesUploaded: data.bytesUploaded
        };

        _this3.uppy.emit('upload-success', file, uploadResp);

        queuedRequest.done();

        if (_this3.uploaderEvents[file.id]) {
          _this3.uploaderEvents[file.id].remove();

          _this3.uploaderEvents[file.id] = null;
        }

        return resolve();
      });
      socket.on('error', function (errData) {
        var resp = errData.response;
        var error = resp ? opts.getResponseError(resp.responseText, resp) : new ErrorWithCause(errData.error.message, {
          cause: errData.error
        });

        _this3.uppy.emit('upload-error', file, error);

        queuedRequest.done();

        if (_this3.uploaderEvents[file.id]) {
          _this3.uploaderEvents[file.id].remove();

          _this3.uploaderEvents[file.id] = null;
        }

        reject(error);
      });
    }).catch(function (err) {
      _this3.uppy.emit('upload-error', file, err);

      return Promise.reject(err);
    });
  });
}